import React from 'react';
import './Modal.css';
import { apiConstants } from '../constants/apiurl.constant';


const BlogModal = ({ show, onClose, blog }) => {
    if (!show) return null;

    const { title, image, description } = blog;
    const fullText = description?.blocks?.[0]?.text || '';

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <button className="close-btn" onClick={onClose}>
                        <svg width="20" height="25" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="blogImage-container">
                        <img src={`${apiConstants.imgUrl}${image}`} alt={title} className="modal-image" />
                        <div className="image-overlay"></div>
                    </div>

                    <div className="content-section">
                        <h2 className="modal-title">{title}</h2>
                        <div className="title-divider"></div>
                        <div className="description-container">
                            <p className="modal-description">{fullText}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogModal;